/**
 * Gives the Sales Insights core page the mockup's look: its font, colors and
 * text size. Everything inside this wrapper can use the `si-` Tailwind classes
 * (text-si-ink, bg-si-surface, …). The app's header and sidebar sit outside
 * it and keep their own look.
 */

import type { ReactNode } from "react";
// Hanken Grotesk at the four weights the mockup uses
import "@fontsource/hanken-grotesk/400.css";
import "@fontsource/hanken-grotesk/500.css";
import "@fontsource/hanken-grotesk/600.css";
import "@fontsource/hanken-grotesk/700.css";

export function InsightsTheme({ children }: { children: ReactNode }) {
  return (
    // si-theme turns on the color values (index.css); the rest set the font,
    // body text size, line height, text color and background
    <div className="si-theme font-si text-si-md leading-[1.45] text-si-ink bg-si-bg">
      {children}
    </div>
  );
}
